import React, { useState, useEffect, useRef } from "react";
import DashBoardTable from "../ProGridTable/DashBoardTable";
import { getApi } from '../../../../utils/services'
import { JTA_AVERAGE_GAUGE_PROJECT_DATA } from "../../../../utils/services/apiPath";
import { roundToTwoDecimals } from "../../../../utils/formHelper";

const formatDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toISOString().split("T")[0];
};

const ProjectHoursTable = ({ selectedProjectsQuery }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const hasFetchedData = useRef(false);
  const columns = [
    { field: "projectName", headerName: "Project Name" },
    { field: "projectStartDate", headerName: "Project Start Date" },
    { field: "projectEndDate", headerName: "Project End Date" },
    { field: "jToA", headerName: "Journey to Apprentice Ratio" },
    { field: "otjHours", headerName: "OTJ Hours" },
    { field: "totalHours", headerName: "Labor Hours" }
  ];

  const fetchProjectHoursTable = async () => {
    setLoading(true);
    try {
      const { data, error } = await getApi(`${JTA_AVERAGE_GAUGE_PROJECT_DATA}?projectIds=${selectedProjectsQuery}`);
      if (error) {
        throw new Error(error);
      }

      const filteredData = data.filter(item => item.jToA < 15);

      const rowsWithId = filteredData.map((item, index) => ({
        id: `row-${index}`,
        projectName: item.projectName,
        projectStartDate: formatDate(item.projectStartDate),
        projectEndDate: formatDate(item.projectEndDate),
        otjHours: roundToTwoDecimals(item.otjHours),
        totalHours: roundToTwoDecimals(item.totalHours),
        jToA: roundToTwoDecimals(item.jToA)
      }));

      setRows(rowsWithId);
    } catch (error) {
      errorToast(error)
    }
    finally { setLoading(false); }
  };

  useEffect(() => {
    if (!hasFetchedData.current) {
      hasFetchedData.current = true;
      fetchProjectHoursTable();
    }
  }, [selectedProjectsQuery]);

  return (
    <div style={{ margin: "20px" }}>
      <DashBoardTable
        title=""
        columns={columns}
        rows={rows}
        loading={loading}
        paginationModel={{ page: 0, pageSize: 5 }}
        hideExport={false}
        checkboxSelection={false}
      />
    </div>
  );
};

export default ProjectHoursTable;
